/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import can from 'can';
import template from './video-feed.stache';
import Swiper from 'swiper';
import DomEventsManager from 'scripts/dom-events-manager';

Component.extend({
    tag: 'video-feed',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            type: {
                type: 'string',
                value: null
            },
            activeCard: {
                Type: can.Map,
                Value: null
            },
            videoCards: {
                Type: can.List,
                Value: can.List
            },
            currentCards: {
                Type: can.List,
                Value: can.List
            },
            fetching: {
                type: 'boolean',
                value: false
            },
            playAll: {
                type: 'boolean',
                value: false
            },
            loadMore: {
                type: 'boolean',
                value: false
            },
            dtmTrack: {
                type: 'boolean'
            },
            dtmVideoLocation: {
                type: 'string',
            },
            defaultLimit: {
                type: 'number',
                value: 2
            }
        },

        loadCards () {
            if(!this.playlist.loadVideos) {
                return can.Deferred().resolve();
            }
            if (this.attr('fetching')) {
                return can.Deferred().reject();
            }

            this.attr('fetching', true);

            return this.playlist.loadVideos()
                .then(() => {
                    this.attr('fetching', false);
                    this.attr('loadMore', this.playlist.canNext());
                })
                .fail(() => {
                    console.log('fail');
                    this.attr('fetching', false);
                });
        },
        selectCard (event) {
            if (event && event.payload.cardIndex != null) {
                this.attr('dtmTrack', true);
                this.attr('dtmVideoLocation', 'Video Detail Feed');
                const playlist = this.attr('playlist');
                playlist.setVideo(event.payload.cardIndex);
                this.attr('activePlaylist', playlist);
            }
        },
        isActiveCard (index) {
            const activeType = this.attr('activePlaylist.type');
            const playlist = this.attr('playlist');
            return activeType === playlist.attr('type') && index === playlist.attr('activeIndex');
        },
        getSwiperOptions (screen) {
            let slidesPerGroup = 1;

            switch (screen) {
                case 'extra-large':
                    slidesPerGroup = 3;
                    break;
                case 'large':
                    slidesPerGroup = 3;
                    break;

            }

            return {
                watchSlidesVisibility: true,
                slidesPerGroup: slidesPerGroup,
                slidesPerView: 'auto',
                hashNavigation: false,
                simulateTouch: true,
                speed: 1000,
                navigation: {
                    nextEl: this.$swimLane.find('.swiper-button-next'),
                    prevEl: this.$swimLane.find('.swiper-button-prev')
                }
            };
        },

        initSwiper (screen) {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }

            let options = this.getSwiperOptions(screen);
            this.swiper = new Swiper(this.$swimLane.find('.swiper-container'), options);

            this.swiper.on('slideChange', () => {
                if (this.swiper.slidesSizesGrid.length - this.swiper.realIndex < this.playlist.attr('limit') * 2) {
                    this.attr('loadMore') && this.loadCards().then(() => {
                        this.swiper.update();
                    });
                }
            });
        },
    },

    events: {
        inserted () {
            this.viewModel.$swimLane = this.element.find('.s-swim-lane');
            DomEventsManager.subscribe(this);
        },
        onLayout (screen) {
            this.viewModel.defaultLimit = screen && !(screen === 'large' || screen === 'extra-large') ? 4 : 8;
            let limit = this.viewModel.defaultLimit;

            this.viewModel.playlist.attr('limit', limit);

            if (!this.loaded) {
                this.initialLoading = this.viewModel.loadCards();
                this.loaded = true;
            }

            this.initialLoading.then(() => this.viewModel.initSwiper(screen));
        }
    }
});

